import React, { useState } from 'react'
import { WifiOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useSync } from '../../../../hooks/useSync'
import { ServerStatusDialog } from './ServerStatusDialog'
import './OfflineIndicator.scss'

/**
 * Compact offline badge shown in the LifeSpacesSidebar when the server is unreachable.
 *
 * Displays a WifiOff icon with "Offline" label. Clicking opens the {@link ServerStatusDialog}
 * with retry countdown and detail cards.
 *
 * Only renders when `!isOnline || !isSupabaseReachable`.
 */
export const OfflineIndicator: React.FC = () => {
  const { t } = useTranslation()
  const { isOnline, isSupabaseReachable } = useSync()
  const [dialogOpen, setDialogOpen] = useState(false)

  if (isOnline && isSupabaseReachable) return null

  console.log('[OfflineIndicator] 🔴 Showing — isOnline:', isOnline, '| isSupabaseReachable:', isSupabaseReachable)

  return (
    <>
      <button
        className="offline-indicator"
        onClick={() => setDialogOpen(true)}
        title={t('sync.serverStatus.title')}
      >
        <WifiOff size={16} className="offline-indicator__icon" />
        <span className="offline-indicator__label">{t('sync.offline')}</span>
      </button>

      <ServerStatusDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </>
  )
}
